export default __webpack_public_path__ + "static/how-it-works-7f9b30bde77ef4b1de369056c997a997.png";